var map = {
	"src/app/appointment/appointment.module": [
		"./src/app/appointment/appointment.module.ts",
		"default~src-app-appointment-appointment-module~src-app-patients-patients-module",
		"src-app-appointment-appointment-module"
	],
	"src/app/directory/directory.module": [
		"./src/app/directory/directory.module.ts",
		"src-app-directory-directory-module"
	],
	"src/app/drive/drive.module": [
		"./src/app/drive/drive.module.ts",
		"src-app-drive-drive-module"
	],
	"src/app/home/home.module": [
		"./src/app/home/home.module.ts",
		"src-app-home-home-module"
	],
	"src/app/journal/journal.module": [
		"./src/app/journal/journal.module.ts",
		"src-app-journal-journal-module"
	],
	"src/app/log/log.module": [
		"./src/app/log/log.module.ts",
		"src-app-log-log-module"
	],
	"src/app/medicine/medicine.module": [
		"./src/app/medicine/medicine.module.ts",
		"src-app-medicine-medicine-module"
	],
	"src/app/patients/patients.module": [
		"./src/app/patients/patients.module.ts",
		"default~src-app-appointment-appointment-module~src-app-patients-patients-module"
	],
	"src/app/practice/practice.module": [
		"./src/app/practice/practice.module.ts"
	],
	"src/app/practitioner/practitioner.module": [
		"./src/app/practitioner/practitioner.module.ts",
		"src-app-practitioner-practitioner-module"
	],
	"src/app/reports/reports.module": [
		"./src/app/reports/reports.module.ts",
		"src-app-reports-reports-module"
	],
	"src/app/settings/settings.module": [
		"./src/app/settings/settings.module.ts",
		"src-app-settings-settings-module"
	],
	"src/app/survey/survey.module": [
		"./src/app/survey/survey.module.ts",
		"src-app-survey-survey-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;